export function CheckboxGroup({ name, options, values, onChange, children }) {
  const toggle = (optionValue) => {
    const next = values.includes(optionValue)
      ? values.filter((v) => v !== optionValue)
      : [...values, optionValue];
    onChange(next);
  };

  return (
    <div className="question checkbox-group">
      <div className="question-title">{children}</div>
      {options.map((option, i) => {
        const optionId = `${name}-${i}`;
        const checked = values.includes(option.value);
        return (
          <label key={optionId} className="checkbox-container" htmlFor={optionId}>
            <input
              type="checkbox"
              name={name}
              id={optionId}
              checked={checked}
              onChange={() => toggle(option.value)}
            />
            <span className="checkbox-mark" />
            <span className="label">{option.label}</span>
          </label>
        );
      })}
    </div>
  );
}
